import { memo } from 'react'
import { Box } from '@maas-components/core'
import _get from 'lodash/get'
import { getFirstLetter } from 'core/common/utils/string'
import { StyledAvatar, StyledLabel } from './style'
import { IVariation } from './types'

const VariationItemView = ({ variation }: { variation: IVariation }) => {
  const renderAvatar = (variation: IVariation) => {
    const color = _get(variation, 'color')
    const firstLetter = getFirstLetter(variation.label)

    return (
      <StyledAvatar className="mr-1" data-testid={color || firstLetter} color={color}>
        {!color && firstLetter}
      </StyledAvatar>
    )
  }

  return (
    <Box className="d-flex align-center">
      {variation.showAvatar && renderAvatar(variation)}
      <StyledLabel className="pr-1">{variation.label}</StyledLabel>
    </Box>
  )
}

export default memo(VariationItemView)
